module.exports = __webpack_public_path__ + "f4b98d57b128fa008e45bc57c67cca5a.MP3";